import React, { useEffect } from 'react';

function LoqateAddressFinder(props) {
   

  useEffect(() => {
        const fields = [
            { element: "search", field: "" , mode: window.pca.fieldMode.SEARCH},
            { element: "COMPANY", field: "Company", mode: window.pca.fieldMode.POPULATE | window.pca.fieldMode.PRESERVE },
            { element: "ADDRESS1", field: "Line1" },
            { element: "ADDRESS2", field: "Line2", mode: window.pca.fieldMode.POPULATE },
            { element: "ADDRESS3", field: "Line3", mode: window.pca.fieldMode.POPULATE },
            { element: "CITY", field: "City", mode: window.pca.fieldMode.POPULATE },
            { element: "COUNTY", field: "Province", mode: window.pca.fieldMode.POPULATE },
            { element: "POSTCODE", field: "PostalCode" },
            { element: "COUNTRY", field: "CountryName", mode: window.pca.fieldMode.COUNTRY }
      ];
      
        const inputSearch = document.getElementById("search");

        const options = props.options;  //options for loqate

        const control = new window.pca.Address(fields, options);   //new address instance

        // suppress Loqate's auto-hide when we're programmatically reopening the list.
        // Loqate's checkHide fires on document mousedown/click and hides the list
        // whenever the target isn't part of the autocomplete container. We temporarily
        // suppresing hide() during our reopen flow and restore it afterwards.
        let suppressHide = false;
        let originalHide = null;
        if (control.autocomplete) {
            originalHide = control.autocomplete.hide.bind(control.autocomplete);
            control.autocomplete.hide = function () {
                if (suppressHide) return;
                return originalHide();
            };
        }

        control.listen("populate", function(address, variations) {   
            props.setLoqateProps(address);                          //gets use the address field on selection
            
        });

        control.listen("load", function() {   //wait for DOM to be ready
            control.setCountry("GBR");       // Set the default country (example: "GBR" for United Kingdom)
            inputSearch.setAttribute("autocomplete","none")
        });
       
        //re-open list on search value
        const reopenList = () => {
            if (inputSearch && inputSearch.value) {

                if (control.autocomplete) {
                    control.autocomplete.field = inputSearch;
                    control.autocomplete.positionField = inputSearch;
                    control.autocomplete.focused = true;
                }

                //loqate's hide event sometimes cause issues with the showList event.
                suppressHide = true;

                control.searchContext = null;
                control.search(inputSearch.value);

                // Re-enable hide on the next frame — by then the event that
                // triggered checkHide has fully propagated and won't interfere.
                setTimeout(() => {
                    suppressHide = false;
                }, 100);
            }
        };

        //when we re-focus through the mouse click

        const handleClick = () => reopenList();

        inputSearch?.addEventListener("click", handleClick);

        control.load();
         
        //when we re-focus through keyboard tab 
        const handleKeyup = (e) => {
            const key = e.which || e.keyCode;
            if (key === 9) reopenList();   // 9 = Tab
        };

        
        inputSearch?.addEventListener("keyup", handleKeyup);

        return () => {
            inputSearch?.removeEventListener("click", handleClick);
            inputSearch?.removeEventListener("keyup", handleKeyup);
            control.destroy();    //cleaning up
        };

    }, [props.options]); 

 

    return (<></> );
}

export default LoqateAddressFinder;
